import { createReducer } from "@reduxjs/toolkit";
import {
    deleteReturnSuccess,
  getReturnListSuccess,
  LoadingData,
  loadingList,
  saveReturnListSuccess,
} from "./returnActions";

export interface IReturnState {
  returnList: Array<any>;
  dataCount: number;
  isLoading: boolean;
}

const initialState: IReturnState = {
  returnList: [],
  dataCount: 0,
  isLoading: false,
};

export const returnReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(LoadingData, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(getReturnListSuccess, (state, action) => {
      state = {
        ...state,
        returnList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })

    .addCase(saveReturnListSuccess, (state, action) => {
      state = {
        ...state,
        returnList: action.payload,
      };
      return state;
    })

    .addCase(loadingList, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })

    .addCase(deleteReturnSuccess, (state, action) => {
      const filteredList = state
      .returnList.filter(
        (item) => !action.payload.includes(item.id)
      );
      return {
        ...state,
        returnList: filteredList,
      };
    });
});


